export enum MenuStates {
    NONE = 0,
    ALL_PROJECTS = 1,
    PROJECT = 2,
    ALL_RELEASES = 3,
    RELEASE = 4,
    ALL_SYSTEMS = 5,
    SYSTEM = 6,
    SETTINGS = 7,
    PORTFOLIO = 8
}
